import { Box, Table, TableContainer } from "@mui/material";
import React from "react";

interface Props {
  children: React.ReactNode;
  /** How tall before the body scrolls instead of the page. */
  maxHeight?: number | string;
  /**
   * Below this the table scrolls sideways rather than squashing its columns.
   * Keep it to what the columns genuinely need — too high and it always scrolls.
   */
  minWidth?: number;
}

/**
 * A table that shrinks with the window instead of stretching the page.
 *
 * The admin's tables used to force the whole page wider than the viewport on a
 * narrow window, because a flex/grid child defaults to `min-width: auto` — it
 * refuses to shrink below its content, so a wide table pushes everything out and
 * the page scrolls horizontally as a whole. The `minWidth: 0` here is what lets
 * it shrink; the table then scrolls inside its own box, which is how the member
 * tools behave and what makes them usable on a small screen.
 *
 * Wrap any table that can outgrow its column widths.
 */
const ResponsiveTable: React.FC<Props> = ({
  children,
  maxHeight = "min(460px, 55vh)",
  minWidth = 560,
}) => (
  <Box sx={{ minWidth: 0, width: "100%" }}>
    <TableContainer sx={{ maxHeight, overflowX: "auto" }}>
      <Table size="small" stickyHeader sx={{ minWidth }}>
        {children}
      </Table>
    </TableContainer>
  </Box>
);

export default ResponsiveTable;
